"use client";

import { misc, theme } from "@/common/theme";
import useAnimation from "@/mono/lib/hooks/useAnimation";
import { useScrollRigScrollTrigger } from "@/mono/lib/hooks/useScrollRigScrollTrigger";
import { EASE_CUSTOM_2 } from "@/mono/lib/styles/easing";
import { forwardRef, useImperativeHandle, useRef } from "react";
import styled, { css } from "styled-components";

export const Divider = forwardRef(
  ({ color = theme.textColor, ...props }, ref) => {
    const localRef = useRef();

    const { animateIn, animateOut } = useAnimation({
      inParams: {
        ease: EASE_CUSTOM_2,
        duration: 2,

        onUpdate: (v) => {
          if (localRef.current)
            localRef.current.style.transform = `scaleX(${v})`;
        },
      },
      // outParams: {
      //   duration: 0,
      //   onStart: () => {
      //     if (divider.current) divider.current.setScaleX(0);
      //   },
      // },
    });

    useImperativeHandle(ref, () => ({
      animateIn,
    }));

    return <StyledDivider $color={color} ref={localRef} {...props} />;
  },
);

export function SectionTitle({ children }) {
  const wrapper = useRef();
  const divider = useRef();
  const title = useRef();

  const { animateIn } = useAnimation({
    inParams: {
      duration: 0.5,
      ease: EASE_CUSTOM_2,
      delay: 0.1,
      onUpdate: (v) => {
        if (title.current)
          title.current.style.transform = `translateY(${(1 - v) * 100}%)`;
      },
    },
  });

  useScrollRigScrollTrigger({
    el: wrapper,
    handleIn: () => {
      divider.current?.animateIn({ delay: 0.1 });
      animateIn();
    },

    //handleOut: animateOut,
  });

  return (
    <Wrapper ref={wrapper}>
      {children && (
        <StyledSectionTitle ref={title}>{children}</StyledSectionTitle>
      )}
      <Divider ref={divider} />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100%;
  height: auto;
  overflow: hidden;
`;

const StyledDivider = styled.div`
  width: 100vw;
  height: 1px;
  background: ${({ theme }) => theme.theme.textColor};
  transform: scaleX(0);
  transform-origin: left;
`;

const StyledSectionTitle = styled.h6`
  padding-top: 40rem;
  padding-bottom: 40rem;
  margin-left: ${(props) => props.theme.misc.pagePadding()};
  transform: translateY(100%);
  line-height: 1.2;
`;
